// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"E0-z","subtitle":"F0-z","wrapper":"G0-z","leftArrow":"H0-z","rightArrow":"I0-z"};